const CURRENCIES = {
  // maxStake: per-bet stake cap enforced in the bet slip, null means no cap
  0: { code: 'EUR', sign: '€', intlCode: 'EUR', maxStake: 4000 },
  1: { code: 'TL', sign: '₺', intlCode: 'TRY', maxStake: null },
  2: { code: 'USD', sign: '$', intlCode: 'USD', maxStake: 4000 }
};

const DEFAULT_CURRENCY = CURRENCIES[0];

export const getCurrencyConfig = (currencyId) => {
  return CURRENCIES[currencyId] || DEFAULT_CURRENCY;
};

export default CURRENCIES;
